import { useRef } from "react";
import isEqual from "@tinkoff/utils/is/equal";
export default function useDeepMemo(factory, dependencies) {
    const ref = useRef(undefined);
    if (!ref.current || !isEqual(dependencies, ref.current.dependencies)) {
        ref.current = { dependencies, result: factory() };
    }
    return ref.current.result;
}
